module.exports = "/assets/js/1a2314be40327422ade3725ff193f658.svg";